// 设置Cookie
export function setCookie(value) {
  // 工具函数：判断是否为 IP 地址（支持带端口 192.168.1.100:8080）
  const isIPAddress = (host) => {
    // 先去掉端口
    const ipWithoutPort = host.split(':')[0];
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    return ipRegex.test(ipWithoutPort);
  };

  // 获取 host（带端口）
  const host = window.location.host;
  let domain = '';
  
  // 只有：不是IP + 不是dev环境 → 才计算 domain
  if (!isIPAddress(host) && process.env.VUE_APP_ENV_NAME !== 'dev') {
    try {
      const str = host.split('.')[0] + '.';
      domain = host.replace(str, '');
    } catch (e) {
      domain = '';
    }
  }

  let yw = '';
  let dl = '';
  const evnName = process.env.VUE_APP_ENV_NAME;
  
  if (evnName === 'pro') {
    yw = 'rzTokenYw';
    dl = 'rzTokenDl';
  } else {
    yw = 'rzTokenTestYw';
    dl = 'rzTokenTestDl';
  }

  // 最终配置：IP 自动不写 domain
  const cookieOpts = domain ? `domain=${domain};path=/` : 'path=/';
  
  document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(value)};${cookieOpts}`;
  document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(value)};${cookieOpts}`;
}

export function getCookie() {
  let name = ''
  let evnName = process.env.VUE_APP_ENV_NAME
  if (evnName === 'pro') {
    name = 'rzTokenYw'
  } else {
    name = 'rzTokenTestYw'
  }
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    // 判断cookie的名称是否是需要获取的cookie名字
    let key = name + '='
    if (cookie.startsWith(key)) {
      const cookieValue = cookie.split('=')[1];
      // 执行你的逻辑
      return decodeURIComponent(cookieValue);
    }
  }
}

export function removeCookie(both = 'all') {
  let str = window.location.host.split('.')[0] + '.'
  let domain = window.location.host.replace(str, '')
  let yw = ''
  let dl = ''
  let evnName = process.env.VUE_APP_ENV_NAME
  if (evnName === 'pro') {
    yw = 'rzTokenYw'
    dl = 'rzTokenDl'
  } else {
    yw = 'rzTokenTestYw'
    dl = 'rzTokenTestDl'
  }
  if (evnName === 'dev') {
    if (both === 'all') {
      document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(null)};path=/`;
      document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(null)};path=/`;
    } else if (both === 'yw') {
      document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(null)};path=/`;
    } else if (both === 'dl') {
      document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(null)};path=/`;
    }
  }else {
    if (both === 'all') {
      document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(null)};domain=${domain};path=/`;
      document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(null)};domain=${domain};path=/`;
    } else if (both === 'yw') {
      document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(null)};domain=${domain};path=/`;
    } else if (both === 'dl') {
      document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(null)};domain=${domain};path=/`;
    }
  }
}
